export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {eyebrow && <div className="label-eyebrow mb-2">{eyebrow}</div>}
        <h1
          className="text-4xl sm:text-5xl font-semibold tracking-tight text-[#1C1917]"
          style={{ fontFamily: "Outfit" }}
        >
          {title}
        </h1>
        {description && (
          <p className="text-[#57534E] mt-2 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function Stat({ label, value, hint, accent }) {
  return (
    <div className="card-cafe p-6 min-w-0">
      <div className="label-eyebrow mb-3">{label}</div>
      <div
        className="text-2xl sm:text-3xl font-semibold tracking-tight break-words leading-tight"
        style={{ fontFamily: "Outfit", color: accent || "#1C1917" }}
      >
        {value}
      </div>
      {hint && <div className="text-sm text-[#57534E] mt-1 break-words">{hint}</div>}
    </div>
  );
}

export function formatCZK(n) {
  const num = Number(n || 0);
  return new Intl.NumberFormat("cs-CZ", {
    style: "currency",
    currency: "CZK",
    maximumFractionDigits: 2,
  }).format(num);
}

export function formatQty(n, unit) {
  const num = Number(n || 0);
  const formatted = new Intl.NumberFormat("cs-CZ", { maximumFractionDigits: 3 }).format(num);
  return unit ? `${formatted} ${unit}` : formatted;
}

export function formatDateTime(s) {
  if (!s) return "";
  const d = new Date(s);
  return d.toLocaleString("cs-CZ", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
